import React from "react"
const Facebook = ({
  width = "18",
  className = "",
  height = "18",
  viewBox = "0 0 18 18",
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.993 0h16.013c.549 0 .994.444.994.993v16.013a.993.993 0 01-.994.994h-3.929v-5.413h1.858l.278-2.157h-2.136V9.056c0-.623.173-1.047 1.067-1.047h1.132V6.085A15.222 15.222 0 0013.616 6c-1.641 0-2.765 1.002-2.765 2.843v1.587H9v2.157h1.85V18H.995A.993.993 0 010 17.007V.994C0 .445.444 0 .993 0z"
      fill="#fff"
    />
  </svg>
)

export default Facebook
